import React, { ReactElement } from 'react';
import $ from 'jquery';
import { useDispatch, useSelector } from 'react-redux';
import { MapState } from '../reducer';
import { toggleCategoryAction } from '../actions';
import { hbToggle } from '../../../../utils';

const isSelectedCategory = (selectedCategories: string[], type: string) => {
  if (!selectedCategories) {
    return true;
  }
  return selectedCategories.includes(type);
};

export default function MapFilter(): ReactElement {
  const categories = useSelector((state: { map: MapState }) => state.map.categories);
  const selectedCategories: string[] = useSelector((state: { map: MapState }) => state.map.selectedCategories);
  const dispatch = useDispatch();
  return (
    <div id="chart-filter" className="hb-container closed content-bg">
      <div className="filter-title">
        <h3>
          <span className="disable-select">Filter</span>

          <div className="hb-toggle-trigger-no-auto" onClick={(event) => hbToggle($(event.target as HTMLElement))}>
            <div className="hb-toggle">
              <div className="hb-toggle-icon" />
            </div>
          </div>
        </h3>
      </div>
      <div id="chart-filter-items" className="hb-item-content">
        <div className="hb-item-content-inner">
          <ul id="filterlist">
            {categories.map((t) => (
              <li
                key={t.type}
                className={`${isSelectedCategory(selectedCategories, t.type) ? 'active' : ''} disable-select`}
                onClick={() => {
                  dispatch(toggleCategoryAction(t));
                }}
              >
                <span
                  className="chart-icon"
                  style={{ backgroundImage: `url(${t.iconUrl})`, border: `2px solid ${t.iconBorderColor}`, backgroundColor: t.iconColor }}
                />
                {t.typeName}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
